import React from 'react'
import style from './style.module.less'

const CurrentGuide = ({ content }) => {
  return (
    <div
      className={style.content}
      style={{ padding: 20 }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}

export default CurrentGuide
